import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { styled, useTheme } from "styled-components";

import { Divider, List } from "simplydo/react/ui";

import { useAppSelector } from "store";

const TaskList = styled.div`
  width: 100%;
  padding: 15px;
  border-radius: 5px !important;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: ${({ theme }) => theme.boxShadow};
  h3 {
    color: black;
  }
`;

const HomeTasklist = () => {
  const user = useAppSelector((state) => state.user);
  const theme = useTheme();
  const { t } = useTranslation();
  const org = user?.ownerOrganisation;

  if (!user) return null;

  const tasklistComplete =
    user.engagements.includes("viewedChallenge") &&
    ((user.ideaCount && user.ideaCount > 0) ||
      user.engagements.includes("createdIdea")) &&
    user.profile.avatar &&
    (org?.superadminTags?.innovationType !== "externalInnovation" ||
      (user.profile.linkedin?.length ?? 0) > 0);
  if (tasklistComplete) return null;

  return (
    <TaskList theme={theme}>
      <h3>{t("home.tasklist.title", { user })}</h3>
      <p>{t("home.getStarted.info")}</p>
      <Divider />
      <List relaxed="very">
        <List.Item>
          <List.Icon
            size="large"
            name={
              (
                user.profile.avatar &&
                (user.profile.tagline || user.profile.overview)
              ) ?
                "check circle"
              : "circle outline"
            }
            color={
              (
                user.profile.avatar &&
                (user.profile.tagline || user.profile.overview)
              ) ?
                "green"
              : undefined
            }
          />
          <List.Content style={{ fontSize: 18 }}>
            <Link
              to="/preferences/profile"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.createProfile")}
            </Link>
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Icon
            size="large"
            name={
              user.engagements.includes("viewedChallenge") ?
                "check circle"
              : "circle outline"
            }
            color={
              user.engagements.includes("viewedChallenge") ? "green" : undefined
            }
          />
          <List.Content style={{ fontSize: 18 }}>
            <Link
              to="/challenges/discover"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.viewChall")}
            </Link>
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Icon
            size="large"
            name={
              (
                (user.ideaCount && user.ideaCount > 0) ||
                user.engagements.includes("createdIdea")
              ) ?
                "check circle"
              : "circle outline"
            }
            color={
              (
                (user.ideaCount && user.ideaCount > 0) ||
                user.engagements.includes("createdIdea")
              ) ?
                "green"
              : undefined
            }
          />
          <List.Content style={{ fontSize: 18 }}>
            <Link
              to="/challenges/discover"
              style={{ color: "#000", textDecoration: "underline" }}
            >
              {t("home.tasklist.createIdea")}
            </Link>
          </List.Content>
        </List.Item>
        {org?.superadminTags?.innovationType === "externalInnovation" && (
          <List.Item>
            <List.Icon
              size="large"
              name={
                user.profile.linkedin && user.profile.linkedin.length > 0 ?
                  "check circle"
                : "circle outline"
              }
              color={
                user.profile.linkedin && user.profile.linkedin.length > 0 ?
                  "green"
                : undefined
              }
            />
            <List.Content style={{ fontSize: 18 }}>
              <Link
                to="/preferences/profile"
                style={{ color: "#000", textDecoration: "underline" }}
              >
                {"Add your LinkedIn"}
              </Link>
            </List.Content>
          </List.Item>
        )}
      </List>
    </TaskList>
  );
};

export default HomeTasklist;
